import { DragOverlay } from '@dnd-kit/core';
import { SortableContext } from '@dnd-kit/sortable';
import 'react';
import { createPortal } from 'react-dom';
import { DragItem, Item } from './DragItem.js';
import { Wrapper } from './styles.js';
import { jsxs, Fragment, jsx } from '@emotion/react/jsx-runtime';

function SortableContainer({
  style,
  idArray,
  Container,
  columns,
  horizontal,
  renderItem,
  handle,
  useDragOverlay,
  adjustScale,
  dropAnimation,
  hideCopy,
  activeId,
  activeIndex,
  wrapperStyle,
  getNewIndex,
  handleRemove,
  animateLayoutChanges,
  getItemStyles,
  strategy,
  colorCoder,
  isDisabled
}) {
  return jsxs(Fragment, {
    children: [jsx(Wrapper, {
      style: style,
      children: jsx(SortableContext, {
        items: idArray,
        strategy: strategy,
        children: jsx(Container, {
          columns: columns,
          horizontal: horizontal,
          customItem: Boolean(renderItem),
          style: style,
          children: idArray.map((value, index) => {
            return jsx(DragItem, {
              id: value,
              handle: handle,
              horizontal: horizontal,
              index: index,
              color: colorCoder(value),
              style: getItemStyles,
              disabled: isDisabled(value.toString()),
              renderItem: renderItem,
              animateLayoutChanges: animateLayoutChanges,
              useDragOverlay: useDragOverlay,
              getNewIndex: getNewIndex,
              onRemove: handleRemove,
              wrapperStyle: wrapperStyle
            }, value);
          })
        })
      })
    }), useDragOverlay && createPortal(jsx(DragOverlay, {
      adjustScale: adjustScale,
      dropAnimation: dropAnimation,
      children: activeId && !hideCopy ? jsx(Item, {
        dragOverlay: true,
        color: colorCoder(activeId),
        handle: handle,
        horizontal: horizontal,
        renderItem: renderItem,
        value: idArray[activeIndex],
        style: getItemStyles({
          id: idArray[activeIndex],
          index: activeIndex,
          isSorting: activeId !== null,
          isDragging: true,
          overIndex: -1,
          isDragOverlay: true
        }),
        wrapperStyle: wrapperStyle({
          active: {
            id: activeId
          },
          index: activeIndex,
          isDragging: true,
          id: idArray[activeIndex]
        })
      }) : null
    }), document.body)]
  });
}

export { SortableContainer as default };
